// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/index.css
// module id = 8592
// module chunks = 2